// extracted by mini-css-extract-plugin
export default {"card":"styles_card__x-emD","value":"styles_value__TzVe+"};